module.exports = __webpack_public_path__ + "static/img/BIRMINGHAM-OAK.7cc714e.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/BIRMINGHAM-OAK.png
// module id = Xzn1
// module chunks = 0